<template>
    <ul class="view-switch">
        <li class="view-item card"
            :class="{
                'active': active === 'card'
            }"
            title="卡片视图"
            @click="doSelect('card')">
            <a></a>
        </li>
        <li class="view-item list"
            :class="{
                'active': active === 'list'
            }"
            title="列表视图"
            @click="doSelect('list')">
            <a></a>
        </li>
    </ul>
</template>

<script>
    import urlUtil from '@souche-f2e/chunyan-util/url_util/url_util.js';
    const locationObj = urlUtil.initByLocation();
    export default {
        data() {
            return {
                key: 'viewType',
                active: locationObj.search.get('viewType') || 'card'
            };
        },
        methods: {
            doSelect(value) {
                if (value) {
                    locationObj.s(this.key, value).go();
                } else {
                    locationObj.s(this.key, null).go();
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// ViewSwitch.vue?4215ce76